import { render, staticRenderFns } from "./baoxiuAudit.vue?vue&type=template&id=20911bb8&scoped=true"
import script from "./baoxiuAudit.vue?vue&type=script&lang=js"
export * from "./baoxiuAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20911bb8",
  null
  
)

export default component.exports